import { render } from "./UserStoriesBlock.vue?vue&type=template&id=17ea70fc"
import script from "./UserStoriesBlock.vue?vue&type=script&lang=js"
export * from "./UserStoriesBlock.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/landing/landing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__